module.exports = __webpack_public_path__ + "static/media/wifi.7767caae.svg";